/**
 * PurchaseConsentCheckbox — iter238 (Variante B §6, §20)
 *
 * Vor jedem PPV-/SINGLE_BUY-Kauf MUSS der Käufer diese Nutzungsrechte
 * bestätigen. Wortlaut aus dem User-PDF §20.
 */
import { ScrollText } from "lucide-react";
import { useTranslation } from "react-i18next";

export const PURCHASE_CONSENT_TEXT =
  "Ich erhalte ein persönliches, nicht übertragbares, nicht kommerzielles Nutzungsrecht an der aktuell angezeigten Version dieses Paid-Media-Inhalts. Ich darf sie einmal für meine persönliche Nutzung herunterladen.";

export default function PurchaseConsentCheckbox({ checked, onChange, testId = "purchase-consent-checkbox" }) {
  const { t } = useTranslation();
  return (
    <label
      data-testid={testId}
      className={`flex items-start gap-3 p-3 rounded-2xl border cursor-pointer transition-colors ${
        checked ? "border-[#0A0A0A] bg-[#FAFAFA]" : "border-[#E5E5E5] bg-white"
      }`}
    >
      <input
        type="checkbox"
        data-testid={`${testId}-input`}
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
        className="mt-0.5 shrink-0"
      />
      <div className="flex-1 space-y-1">
        <div className="flex items-center gap-2">
          <ScrollText size={14} className="text-[#0A0A0A]" />
          <span className="text-xs font-semibold text-[#0A0A0A]">
            {t("paid_media.purchase_consent_title", { defaultValue: "Nutzungsrechte akzeptieren" })}
          </span>
        </div>
        <p className="text-[11px] leading-snug text-[#666]">
          {t("paid_media.purchase_consent_text", { defaultValue: PURCHASE_CONSENT_TEXT })}
        </p>
      </div>
    </label>
  );
}
